import type { AutocompleteProps } from "@heroui/autocomplete";
import {
	BOARDS_KEY_MAPPER_ENUM,
	MARKETING_PLAN_COLUMNS,
	MARKETING_PLAN_STATUS,
} from "@onesolution/constants";
import { type AppFormApi, useLanguage } from "@onesolution/hooks";
import { getItemPageByValuesFromServer } from "@onesolution/serverFn";
import lodash from "lodash";

export default function MarketingPlansSelector(
	props: {
		name: string;
		form: AppFormApi;
	} & Omit<AutocompleteProps, "children" | "form">,
) {
	const { t } = useLanguage();
	const { form, name, ...restProps } = props;

	const marketingPlans = getItemPageByValuesFromServer.useQuery({
		boardId: BOARDS_KEY_MAPPER_ENUM.marketingPlan,
		columnIds: [MARKETING_PLAN_COLUMNS.name],
		filter: [
			{
				column_id: MARKETING_PLAN_COLUMNS.status,
				column_values: lodash.without(
					Object.values(MARKETING_PLAN_STATUS),
					MARKETING_PLAN_STATUS.Canceled,
					MARKETING_PLAN_STATUS.Complete,
				),
			},
		],
	});

	return (
		<form.AppField name={name}>
			{(field) => (
				<field.Autocomplete
					label={t("basic.marketing_plan")}
					placeholder={t("basic.marketing_plan")}
					defaultItems={marketingPlans.data}
					isLoading={marketingPlans.isLoading}
					{...restProps}
				/>
			)}
		</form.AppField>
	);
}
